/** Placement of vector chunks on their terrain, in a worker. See `workers/place.worker.ts`. */

import type { TerrainMeshData } from '../core/build/terrainmesh.js';
import type { VectorChunkData } from '../core/build/vectorfeatures.js';
import type { Placer } from '../core/world.js';
import { WorkerPool } from '../workers/pool.js';
import type { PlaceJob, PlaceResult } from '../workers/protocol.js';

export function createPlacementWorkers(workers: number): Placer & { dispose(): void } {
  const pool = new WorkerPool<PlaceJob, PlaceResult>(
    () => new Worker(new URL('../workers/place.worker.ts', import.meta.url), { type: 'module' }),
    workers,
  );
  return {
    place(data: VectorChunkData, terrain: TerrainMeshData, pristine: Float32Array, dayOfYear: number) {
      // The terrain goes as a fresh copy on its pristine grid; its large
      // arrays are new, so they can be transferred rather than cloned. The
      // vector chunk is cloned: the scheduler keeps it, to place it again.
      const copy: TerrainMeshData = {
        ...terrain,
        // The renderer's: placing needs none of them.
        facets: undefined,
        gridHeights: pristine.slice(),
        positions: terrain.positions.slice(),
        normals: terrain.normals.slice(),
      };
      return pool.run({ data, terrain: copy, dayOfYear }, [copy.gridHeights.buffer, copy.positions.buffer, copy.normals.buffer]);
    },
    dispose: () => pool.dispose(),
  };
}
